<template>
  <div>
    <!-- Hero区域 -->
    <div class="hero-section pt-16 relative overflow-hidden" id="about">
      <div
        class="absolute inset-0 bg-gradient-to-r from-blue-900 to-transparent z-0"
      >
        <img
          src="../assets/home1.jpg"
          alt="Hero Background"
          class="w-full h-full object-cover object-top opacity-80"
        />
      </div>
      <div class="container mx-auto px-6 py-20 md:py-32 relative z-10">
        <div class="flex flex-col md:flex-row items-center">
          <div class="w-full md:w-1/2 text-white mb-12 md:mb-0">
            <h1 class="text-4xl md:text-5xl font-bold mb-6">
              创新科技，引领未来
            </h1>
            <p class="text-lg md:text-xl mb-8">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;创达芯仪科技致力于人工智能、边缘计算和传感器技术的创新研发，为交通、民航、市政等行业提供先进的产品技术和系统解决方案。
            </p>
            <div
              class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
            >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <section class="bg-white py-16 md:py-24">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            关于创达
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto"></div>
        </div>
        <div class="flex flex-col md:flex-row items-center">
          <div class="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10">
          <!-- ../assets/aboutus.jpg-->
            <img
              src="../assets/aboutus.jpg"
              alt="关于创达"
              class="rounded-lg shadow-xl w-full h-auto object-cover"
            />
          </div>
          <div class="w-full md:w-1/2">
            <h3 class="text-2xl font-bold text-gray-800 mb-4">关于我们</h3>
            <p class="text-gray-700 mb-6 leading-relaxed">
              <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;四川创达芯仪科技有限公司</span>，于 2023
              年在成都创立。我们公司立足于前沿科技，致力于人工智能、边缘计算、声学技术、传感器技术和大数据分析等领域的创新研究与产品开发。我们为交通、民航、市政等行业提供先进的产品技术和系统解决方案，以增强客户的核心竞争力。
            </p>
            <p class="text-gray-700 mb-6 leading-relaxed">
              <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;创达芯仪科技有限公司与电子科技大学</span>、西南交通大学、北京理工大学等知名学府在
              AI
              算法、传感器技术等方面展开深度合作，共同推动产品创新。凭借卓越的产品实力，我们已成功入选为中国铁塔的行业战略合作伙伴。
            </p>
            <p class="text-gray-700 mb-6 leading-relaxed">
              <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;在创达芯仪</span>，我们不仅追求技术的卓越，更致力于通过创新技术推动行业进步，为社会创造更大的价值。
            </p>
            <h3 class="text-2xl font-bold text-gray-800 mb-4">核心价值观</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-lightbulb text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    创新驱动
                  </h4>
                  <p class="text-gray-600">
                    不断探索前沿技术，引领行业发展方向
                  </p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-users text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    客户至上
                  </h4>
                  <p class="text-gray-600">
                    以客户需求为中心，提供卓越的产品和服务
                  </p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-shield-alt text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    诚信负责
                  </h4>
                  <p class="text-gray-600">坚持诚信经营，对客户和社会负责</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-handshake text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    合作共赢
                  </h4>
                  <p class="text-gray-600">与合作伙伴建立长期稳定的互利关系</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 产品与服务 -->
    <section class="bg-blue-50 py-16 md:py-24" id="products">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            产品与服务
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
          <p class="text-gray-700 max-w-3xl mx-auto">
            我们提供全方位的技术解决方案，帮助企业应对数字化转型挑战，提升业务效率和竞争力。
          </p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- 产品卡片1 -->
          <div
            class="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 hover:scale-105"
           @click="toProduct(1)" >
            <div class="h-48 overflow-hidden">
              <img
                src="/img/p-1.png"
                alt="AI智慧驱鸟系统"
                class="w-full h-full object-cover object-top"
              />
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-gray-800 mb-3">
                AI智慧驱鸟系统
              </h3>
              <p class="text-gray-600 mb-4">
                运用先进的计算机视觉和声学技术，智能识别和驱散鸟类，保护农作物和城市环境，提供生态友好的解决方案。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >计算机视觉</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >声学技术</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >生态保护</span
                >
              </div>
              
            </div>
          </div>
          <!-- 产品卡片2 -->
          <div
            class="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 hover:scale-105"
            @click="toProduct(2)">
            <div class="h-48 overflow-hidden">
              <img
                src="/img/p2-1.png"
                alt="城市积水智能监测预警系统"
                class="w-full h-full object-cover object-top"
              />
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-gray-800 mb-3">
                城市积水智能监测预警系统
              </h3>
              <p class="text-gray-600 mb-4">
                整合气象数据和排水系统监测，通过智能预警和自动调控，有效预防和应对城市内涝问题，保障城市安全。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >智能预警</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >排水监测</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >城市安全</span
                >
              </div>
              
            </div>
          </div>
          <!-- 产品卡片3 -->
          <div
            class="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 hover:scale-105"
            @click="toProduct(3)">
            <div class="h-48 overflow-hidden">
              <img
                src="../assets/p3-1.png"
                alt="行业AI边缘网关"
                class="w-full h-full object-cover object-top"
              />
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-gray-800 mb-3">
                行业AI边缘网关
              </h3>
              <p class="text-gray-600 mb-4">
                提供高性能边缘计算设备，实现数据本地处理和分析，降低延迟，提高效率，适用于工业物联网和智能制造场景。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >边缘计算</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >工业物联网</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >实时分析</span
                >
              </div>
             
            </div>
          </div>
          <!-- 产品卡片4 -->
          <div
            class="bg-white rounded-lg shadow-lg overflow-hidden transform transition-transform duration-300 hover:scale-105"
            @click="toProduct(4)">
            <div class="h-48 overflow-hidden">
              <img
                src="../assets/product4.jpg"
                alt="软硬件定制服务"
                class="w-full h-full object-cover object-top"
              />
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-gray-800 mb-3">
                软硬件定制服务
              </h3>
              <p class="text-gray-600 mb-4">
                根据客户需求提供定制化的软硬件解决方案，从需求分析到设计开发、测试部署，提供全流程专业服务。
              </p>
              <div class="flex flex-wrap gap-2 mb-4">
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >定制开发</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >嵌入式系统</span
                >
                <span
                  class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
                  >全流程服务</span
                >
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </section>
   



    <!-- 合作伙伴 -->
    <section class="bg-gray-50 py-16 md:py-24" id="partners">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            合作伙伴
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
          <p class="text-gray-700 max-w-3xl mx-auto">
            我们与众多行业领先企业建立了长期稳定的合作关系，共同推动技术创新和行业发展。
          </p>
        </div>
     
       
       <div
          class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 items-center"
        >
            <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-microsoft text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c1.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c2.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c3.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c4.png"
          /></span>
        </div>
          
        </div>
       </div>  
    </section>
  </div>
</template>


<script>
export default {
   name: 'HomePage',
   data() {
    return {
      activeNav: "about",
      mobileMenuOpen: false,
      stats: {
        clients: 500,
        projects: 1200,
        team: 150,
        years: 15,
      },
      contactForm: {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      },
    };
  },
  methods: {
    setActiveNav(navItem) {
      this.activeNav = navItem;
      this.mobileMenuOpen = false;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    handleMobileNavClick(navItem) {
      this.setActiveNav(navItem);
      this.mobileMenuOpen = false;
    },
    submitContactForm() {
      // 这里可以添加表单提交逻辑
      alert("感谢您的留言，我们将尽快与您联系！");
      // 重置表单
      this.contactForm = {
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
      };
   
     },
    toProduct(idx) {
      this.$router.push({
        name: 'ProductPage',
        query: { 
          id: idx
      }
    });
    }
  },
};

</script>   

<style scoped>
.height140 {
  height: 140px;
}
</style>